import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, renderSlot, createVNode } from "vue";
import { _ as _sfc_main$1 } from "./p-icon.js";
const _hoisted_1 = { class: "flex" };
const _hoisted_2 = { class: "pr-2" };
const ALERT_TYPES = {
  info: { classes: `bg-info text-on-info`, icon: "streamline:information-circle-solid" },
  warning: { classes: `bg-warning text-on-warning`, icon: "streamline:warning-triangle-solid" },
  error: { classes: `bg-error text-on-error`, icon: "streamline:warning-octagon-solid" },
  success: { classes: `bg-success text-on-success`, icon: "streamline:check-square-solid" }
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PAlert"
  },
  __name: "p-alert",
  props: {
    type: {
      type: String,
      default: "info",
      validator(value) {
        return Object.keys(ALERT_TYPES).includes(value);
      }
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["rounded p-4 text-xs font-semibold", ALERT_TYPES[props.type].classes]),
        role: "alert"
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            renderSlot(_ctx.$slots, "icon", {}, () => [
              createVNode(_sfc_main$1, {
                icon: ALERT_TYPES[props.type].icon,
                width: "16",
                class: "-mb-0.5",
                inline: ""
              }, null, 8, ["icon"])
            ])
          ]),
          createElementVNode("div", null, [
            renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2);
    };
  }
});
export {
  _sfc_main as _
};
